import {
    GET_COMPLETE_STATE_DATA, SET_COMPLETE_STATE_DATA,
    GET_COMPLETE_CITY_DATA, SET_COMPLETE_CITY_DATA,
    GET_COMPLETE_PIN_CODE_DATA, SET_COMPLETE_PIN_CODE_DATA, GET_CUMULATION_DATA, SET_CUMULATION_DATA
} from './types'

export const getStateData = (payload) => ({
    type: GET_COMPLETE_STATE_DATA,
    payload,
});
export const setStateData = (payload) => ({
    type: SET_COMPLETE_STATE_DATA,
    payload,
});
export const getCityData = (payload) => ({
    type: GET_COMPLETE_CITY_DATA,
    payload,
});
export const setCityData = (payload) => ({
    type: SET_COMPLETE_CITY_DATA,
    payload,
});
export const getPinCodeData = (payload) => ({
    type: GET_COMPLETE_PIN_CODE_DATA,
    payload,
});
export const setPinCodeData = (payload) => ({
    type: SET_COMPLETE_PIN_CODE_DATA,
    payload,
});

export const getCumulationData = (payload) => ({
    type: GET_CUMULATION_DATA,
    payload,
});
export const setCumulationData = (payload) => ({
    type: SET_CUMULATION_DATA,
    payload,
});